import posthog from "posthog-js";

let promise = null;

const MAX_ATTEMPTS = 2;
const RETRY_DELAY_MS = 2000;

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export function vademecumVariantFor(user) {
  return user?.profile?.healthCenter?.name === "Medicus" ? "medicus" : "default";
}

function fetchVademecum(api, variant, start, attempt) {
  return api.medicationsFile()
    .tap(() => {
      posthog.capture("vademecum_loaded", {
        variant,
        attempt,
        duration_ms: Date.now() - start,
      });
    })
    .catch((error) => {
      if (attempt < MAX_ATTEMPTS) {
        return delay(RETRY_DELAY_MS).then(() => fetchVademecum(api, variant, start, attempt + 1));
      }
      posthog.capture("vademecum_load_failed", {
        variant,
        error: error.message,
        attempts: attempt,
        duration_ms: Date.now() - start,
      });
      // Don't cache the exhausted failure forever: clearing it lets the next
      // caller (e.g. the user reopening the medicine step) try again from
      // scratch, instead of being stuck with [] for the rest of the session.
      promise = null;
      return [];
    });
}

export function prefetchVademecum(api, variant) {
  if (promise) return promise;
  promise = fetchVademecum(api, variant, Date.now(), 1);
  return promise;
}

export function getVademecumPromise() {
  return promise;
}

export function resetVademecumPromise() {
  promise = null;
}
